import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// A suspended account loses access on its very next request, not just at next login.
api.interceptors.response.use(undefined, (err) => {
  if (err?.response?.status === 403 && err.response.data?.detail === "account_suspended" && window.location.pathname !== "/login") {
    window.location.href = "/login?notice=account_suspended";
  }
  return Promise.reject(err);
});

export function wsUrl(path) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}${path}`;
}
